import React from 'react';
import { Row, Col } from 'react-bootstrap';

export const SessionDetailHeader = ({ 
    sessionStatus, 
    timeUntilSession, 
    isSessionInFuture, 
    studentName, 
    tutorName 
}) => {
    const statusColorMap = {
        "Completed": "secondary",
        "Starting Soon": "warning",
        "Scheduled": "primary",
        "Cancelled": "danger",
        "Loading...": "light"
    };

    return (
        <Row className="mb-4">
            <Col className="d-flex align-items-center">
                <div>
                    <h4 className="text-dark font-weight-bold mb-2">
                        Session with Student {studentName || 'Student'}
                    </h4>
                    <span className={`badge bg-${statusColorMap[sessionStatus] || 'secondary'} text-white py-2 px-4 fs-5`}>
                        {sessionStatus}
                    </span>
                    {isSessionInFuture && timeUntilSession && (
                        <span className="ms-3 text-muted">
                            Starting in {timeUntilSession}
                        </span>
                    )}
                    <p className="text-muted mt-2">
                        {sessionStatus === 'Scheduled' 
                            ? 'Session is scheduled. Please prepare any materials in advance.'
                            : sessionStatus === 'Completed'
                            ? 'This session has been completed.'
                            : sessionStatus === 'Cancelled'
                            ? 'This session has been cancelled.'
                            : 'Session details loading...'
                        }
                    </p>
                </div>
            </Col>
        </Row>
    );
};